import Link from 'next/link'

export function EmptyState({
  title = 'Sonuç bulunamadı',
  message = 'Aradığın kriterlere uygun bir sonuç bulamadık.',
  icon = '🎬',
}: {
  title?: string
  message?: string
  icon?: string
}) {
  return (
    <div className="mx-auto max-w-md rounded-2xl border border-white/10 bg-ink-800/60 p-10 text-center">
      <div className="mb-3 text-4xl" aria-hidden>
        {icon}
      </div>
      <h3 className="font-display text-lg font-bold text-white">{title}</h3>
      <p className="mt-2 text-sm text-neutral-400">{message}</p>
    </div>
  )
}

export function ErrorState({
  message = 'İçerikleri getirirken bir sorun oluştu. Lütfen tekrar deneyin.',
  onRetry,
}: {
  message?: string
  onRetry?: () => void
}) {
  return (
    <div className="mx-auto max-w-md rounded-2xl border border-crimson-900/40 bg-crimson-950/20 p-10 text-center">
      <div className="mb-3 text-4xl" aria-hidden>
        ⚠️
      </div>
      <h3 className="font-display text-lg font-bold text-white">Bir sorun oluştu</h3>
      <p className="mt-2 text-sm text-neutral-400">{message}</p>
      {onRetry && (
        <button onClick={onRetry} className="btn-primary mt-5">
          Tekrar Dene
        </button>
      )}
    </div>
  )
}

export function BackHome() {
  return (
    <Link href="/" className="btn-ghost mt-6">
      Ana Sayfaya Dön
    </Link>
  )
}
